var render = function render(_c,_vm){return _c('a',_vm._b({class:[_vm.data.class, _vm.data.staticClass],attrs:{"href":_vm.props.href,"target":"_blank","rel":"noopener noreferrer"}},'a',_vm.data.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }